export const dataTestIds = {
  // 2FA not setup yet
  enableMfaButton: 'security-enable-mfa-button',
  setupSetUpButton: 'security-setup-set-up-button',
  setupCancelButton: 'security-setup-cancel-button',

  // 2FA setup screen
  copySecretKeyButton: 'security-copy-secret-key-button',
  verifyTotpButton: 'security-verify-totp-button',
  cancelTotpButton: 'security-cancel-totp-button',

  // 2FA has been setup
  changeMethodButton: 'security-change-method-button',
  generateCodesButton: 'security-generate-codes-button',
  disableMfaButton: 'security-disable-mfa-button',
} as const;
